import {mapGooglePlaceToRawAddress} from '~/shared/services/addressHelper';
import {GeolocationPlace} from '~/shared/services/geocoder';
import {getTenBisAddressLocation} from '~/shared/services/getTenBisAddressLocation';
import {TenBisAddressLocation} from '~/shared/store/models/Address/TenBisAddressLocation';

export default async function getAddressFinderAddress(
  customHouseNumber: string | undefined,
  place: GeolocationPlace,
): Promise<AddressFinderAddress> {
  const rawAddress = mapGooglePlaceToRawAddress(place);
  if (!rawAddress) {
    return {error: {type: 'unexpected'}};
  }
  const houseNumber =
    customHouseNumber ||
    place.address_components.find(c => c.types.find(t => t === 'street_number'))?.short_name ||
    rawAddress.houseNumber;
  const houseNumberHasNumbers = /\d/.test(houseNumber);

  let address;
  try {
    address = await getTenBisAddressLocation({
      cityName: rawAddress.cityName,
      streetName: rawAddress.streetName,
      houseNumber: houseNumberHasNumbers ? houseNumber : '',
      latitude: rawAddress.latitude,
      longitude: rawAddress.longitude,
    });
  } catch (error: any) {
    const {cityName, isBigCity, streetName, streetId} = error?.responseAddress || {};

    if (!error?.responseAddress) {
      return {error: {type: 'unexpected'}};
    }

    if (!cityName) {
      return {error: {type: 'missing', field: 'city'}};
    }
    if ((isBigCity && !streetName) || !streetId) {
      return {error: {type: 'missing', field: 'street'}};
    }

    return {error: {type: 'unexpected'}};
  }

  const {cityName, streetName, houseNumber: finalHouseNumber} = address;

  if (!cityName) {
    return {error: {type: 'missing', field: 'city'}};
  }

  if (!streetName) {
    return {error: {type: 'missing', field: 'street'}};
  }

  if ((!houseNumber || !houseNumberHasNumbers) && !finalHouseNumber) {
    const field = houseNumber && !houseNumberHasNumbers ? 'house_numbers_also' : 'house_number';
    return {error: {type: 'missing_houseNumber', field}};
  }

  return {data: {...address, houseNumber: finalHouseNumber}};
}

type AddressFinderAddress = {error: AddressFinderError} | {data: TenBisAddressLocation};

interface AddressFinderError {
  type: 'missing' | 'missing_houseNumber' | 'unexpected';
  field?: string;
}
